import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=53e45ec8&scoped=true&"
import script from "./HeaderSection.vue?vue&type=script&lang=js&"
export * from "./HeaderSection.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSection.vue?vue&type=style&index=0&id=53e45ec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e45ec8",
  null
  
)

export default component.exports